import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddUnitLayer from "../../components/Units/AddUnitLayer";





const AddUnitPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  title="Add Unit" />

        {/* Add Unit Layer */}
        <AddUnitLayer />

      </MasterLayout>
    </>
  );
};

export default AddUnitPage;
